import React from "react";
import debounce from "lodash.debounce";
import {TaggedLogger} from "@nextlot/core/utilities";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

const _logger = TaggedLogger.get('BidderLanguageSelectorCmp');

const WEBCAST_LANGUAGES = [
  { code: 'en', name: 'ENG' },
  { code: 'es', name: 'ESP' },
  { code: 'nl', name: 'NLD' },
  { code: 'fr', name: 'FRA' },
  { code: 'de', name: 'DEU' },
];

export default function BidderLanguageSelectorCmp() {
  _logger.debug('.render()')

  const { t, i18n } = useTranslation();
  const lngSelectorContainerRef = React.useRef(null);

  const [selectedLng, setSelectedLng] = React.useState('en');
  const [isLngSelectorOpen, setIsLngSelectorOpen] = React.useState(false);

  const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
  };

  const handleLngSelectorState = () => {
      setIsLngSelectorOpen(!isLngSelectorOpen);
  };

  const handleLanguageChange = (langCode) => {
    setSelectedLng(langCode);
    setIsLngSelectorOpen(!isLngSelectorOpen);
    changeLanguage(langCode);
  };


  const languageLabelMap = React.useMemo(() => {
    return WEBCAST_LANGUAGES.reduce((acc, lng) => {
      acc[lng.code] = lng.name;
      return acc;
    }, {});
  }, []);

  const handleClickOutside = React.useCallback(debounce((event) => {
    if (lngSelectorContainerRef.current && !lngSelectorContainerRef.current.contains(event.target)) {
      setIsLngSelectorOpen(false);
    }
  }, 50), []);


  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  return (
    <div ref={lngSelectorContainerRef} className="position-relative wbs-lng-select--theming">

        <button
          className="hstack gap-1 btn btn-sm bg-white border border-dark shadow shadow-sm wbs-lng-select_button--theming"
          onClick={handleLngSelectorState}
          >
            {languageLabelMap[selectedLng]}
          <i className="fa-regular fa-caret-down"></i>
        </button>

        <ul
            className={classNames("position-absolute top-0 end-0 list-group text-dark bg-white border border-dark shadow wbs-lng-select_dropdown--theming", isLngSelectorOpen ? "d-block" : "d-none")}
            style={{
              marginTop: '36px',
              minWidth: '70px',
              zIndex: 100
            }}
        >
          {
            WEBCAST_LANGUAGES.map((lng, idx) => (
              <button
                  key={idx}
                  className={classNames("list-group-item list-group-item-action text-center", selectedLng === lng.code && 'active')}
                  onClick={() => handleLanguageChange(lng.code)}
              >
                {lng.name}
              </button>
            ))
          }
        </ul>

    </div>
  )

}
